import WithLoader from './WithLoader';

export default WithLoader;
